import React from 'react';
import { Modal, Button } from 'react-bootstrap';

// Custom styles for the modal
const modalStyles = `
.modal-90w {
  max-width: 90%;
  width: auto;
  min-width: 500px;
}
`;

interface MediaPreviewModalProps {
  show: boolean;
  onHide: () => void;
  imageUrl: string | null;
  title: string;
}

const MediaPreviewModal: React.FC<MediaPreviewModalProps> = ({ show, onHide, imageUrl, title }) => {
  // Check if the URL is a video file
  const isVideo = imageUrl?.toLowerCase().endsWith('.mp4') || false;

  return (
    <>
      <style>{modalStyles}</style>
      <Modal show={show} onHide={onHide} dialogClassName="modal-90w" contentClassName="bg-light" centered>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0 text-center">
          <div className="media-container overflow-auto p-3" style={{ maxHeight: '70vh' }}>
            {imageUrl &&
              (isVideo ? (
                <video
                  src={imageUrl}
                  controls
                  style={{
                    maxWidth: '100%',
                    maxHeight: '60vh',
                    objectFit: 'scale-down',
                  }}
                />
              ) : (
                <img
                  src={imageUrl}
                  alt={title}
                  style={{
                    maxWidth: '100%',
                    maxHeight: '60vh',
                    objectFit: 'scale-down',
                  }}
                />
              ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Close
          </Button>
          {imageUrl && (
            <Button variant="primary" as="a" href={imageUrl} target="_blank" rel="noopener noreferrer">
              Open in New Tab
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default MediaPreviewModal;
